import CrossIcon from '../icons/CrossIcon';
import CustomSearchIcon from '../icons/SearchIcon';
import DateRangePickerComponent from '../date-range-picker/DateRangePicker';
import LocationAutocompleteComponent from '../autocomplete/LocationAutocomplete';
import { Body, BodyBold, BodyGrey, BodyLarge } from '../Typography';
import { Box, styled } from '@mui/material';
import { fontWeight } from '../../theme/typography';
import { HFlex, VFlex } from '../FlexContainers';
import { palette } from '../../theme/palette';
import { PrimaryButton } from '../Buttons';

export const Root = styled(HFlex)`
  position: relative;
  z-index: 20;
`;

export const SelectorBar = styled(HFlex)`
  width: 626px;
  height: 65px;
  background: ${palette.custom.white};
  border-radius: 1000px;
`;

export const SelectorDropdown = styled(HFlex)`
  position: absolute;
  left: 0px;
  top: calc(100% + 10px);
  width: 100%;
  border-radius: 20px;
  background: ${palette.custom.white};
  padding: 37px 48px 34px 48px;
  box-shadow:
    0px 8px 15px 0px rgba(0, 0, 0, 0.1),
    0px -8px 15px 0px rgba(0, 0, 0, 0.1);
`;

export const BaseSelector = styled(HFlex, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{
  active?: boolean;
}>`
  width: 100%;
  height: 100%;
  border-radius: 1000px;
  background: ${palette.custom.white};
  align-items: center;
  padding: 5px 10px 5px 35px;
  cursor: pointer;
  background: ${(props) => (props.active ? palette.custom.lightGrey : palette.custom.white)};
  box-shadow: ${(props) => (props.active ? '4px 0px 6px 2px rgba(0, 0, 0, 0.12)' : 'none')};
  backdrop-filter: ${(props) => (props.active ? 'blur(3px)' : 'none')};
`;

export const LocationSelector = styled(BaseSelector)`
  max-width: 216px;
`;

export const DateSelector = styled(BaseSelector)`
  max-width: 182px;
`;

export const SelectorContent = styled(VFlex)`
  max-height: 100%;
  max-width: 100%;
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }
`;

export const Label = styled(BodyBold)`
  margin-bottom: 0px;
  color: ${palette.custom.black};
  letter-spacing: 0.07px;
  line-height: normal;
`;

export const Value = styled(Body, {
  shouldForwardProp: (prop) => prop !== 'lightColor',
})<{
  lightColor?: boolean;
}>`
  color: ${(props) => (props.lightColor ? palette.custom.mediumGrey : palette.custom.darkGrey)};
  font-size: 16px;
  line-height: normal;
  letter-spacing: 0.08px;
  margin-bottom: 0px;
`;

export const SubmitButtonInSelectorBar = styled(PrimaryButton)`
  margin: auto 12px auto 41px;
  width: 175px;
  height: 48px;
  border-radius: 23px;
  font-size: 14px;
  font-weight: ${fontWeight.bold};
  line-height: normal;
  letter-spacing: 0.7px;
`;

export const SubmitButtoninSelectorDropdown = styled(PrimaryButton)`
  width: 100%;
  height: 41px;
  font-style: normal;
  font-weight: ${fontWeight.bold};
  line-height: normal;
  letter-spacing: 0.675px;
`;

export const Form = styled(VFlex)`
  gap: 22px;
  width: 100%;
`;

export const FormItem = styled(Box)``;

export const LocationAutocomplete = styled(LocationAutocompleteComponent, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{
  active?: boolean;
}>`
  border-radius: 5px;
  border: ${(props) =>
    props.active ? `0.75px solid ${palette.primary.main}` : `0.75px solid ${palette.custom.grey}`};
  height: 48px;
`;

export const DateRangePicker = styled(DateRangePickerComponent, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{
  active?: boolean;
}>`
  .date-picker-start-date-container .date-range-picker-field .MuiInputBase-root {
    border-color: ${(props) =>
      props.active ? `${palette.primary.main}` : `${palette.custom.grey}`};
  }
  .date-picker-end-date-container .date-range-picker-field .MuiInputBase-root {
    border-color: ${(props) =>
      props.active ? `${palette.primary.main}` : `${palette.custom.grey}`};
  }
`;

export const FormLabel = styled(BodyLarge)`
  margin-bottom: 5px;
  letter-spacing: 0.4px;
`;

export const HelperText = styled(BodyGrey, {
  shouldForwardProp: (prop) => prop !== 'hasError' && prop !== 'absolutePosition',
})<{
  hasError?: boolean;
  absolutePosition?: boolean;
}>`
  margin-top: ${(props) => (props.hasError && props.absolutePosition ? '0px' : '5px')};
  margin-left: 3px;
  margin-bottom: ${(props) => (props.hasError && props.absolutePosition ? '8px' : '0px')};
  color: ${(props) => (props.hasError ? palette.error.main : palette.custom.mediumGrey)};
  width: fit-content;
`;

export const SearchIcon = styled(CustomSearchIcon)`
  color: ${palette.custom.mediumGrey};
  width: 20px;
`;

export const CloseButton = styled(Box)`
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${palette.primary.main};
  position: absolute;
  top: 16px;
  right: 18px;
`;

export const CloseIcon = styled(CrossIcon)`
  color: ${palette.custom.grey};
  width: 21px;
  height: 21px;
  object-fit: contain;
`;
